"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var sweetalert2_1 = tslib_1.__importDefault(require("sweetalert2"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var showDialog = function (props) {
    var title = props.title, text = props.text, link = props.link, type = props.type, html = props.html, showCancelButton = props.showCancelButton, confirmButtonText = props.confirmButtonText, cancelButtonText = props.cancelButtonText;
    var clickable = link && "<a href=".concat(link, " target=\"_blank\" rel=\"noopener noreferrer\">").concat(link, "</a>");
    return (0, sweetalert2_1.default)({
        title: title,
        text: text,
        type: type,
        html: html || clickable,
        showCancelButton: showCancelButton || false,
        confirmButtonText: confirmButtonText || 'Ok',
        cancelButtonText: cancelButtonText || 'Cancel',
        confirmButtonClass: 'button--primary',
        cancelButtonClass: 'button--secondary',
        customClass: 'swal-global',
    });
};
showDialog.propTypes = {
    title: prop_types_1.default.string,
    text: prop_types_1.default.string,
    type: prop_types_1.default.string,
    html: prop_types_1.default.object,
    showCancelButton: prop_types_1.default.bool,
    confirmButtonText: prop_types_1.default.string,
    cancelButtonText: prop_types_1.default.string,
    confirmButtonClass: prop_types_1.default.string,
    cancelButtonClass: prop_types_1.default.string,
    customClass: prop_types_1.default.string,
};
showDialog.defaultProps = {
    showCancelButton: false,
    confirmButtonText: 'Ok',
    cancelButtonText: 'Cancel',
};
exports.default = showDialog;
